import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { ClientDDL } from "@/views/base/base.types";
import { Medication, Imei, ParticipantStatus } from "@/views/sidebar/participant/participant.types";
import { ErrorBag, Field } from "vee-validate";
import moment from "moment";

@Component({
  computed: {
    ...mapState("Participant", [
      "medications",
      "imeis",
      "participantStatus"
    ]),
    ...mapState("Base", [
      "selectedClientDDL"
    ])
  }
})
export default class ParticipantMixin extends Vue {
  selectedClientDDL!: ClientDDL;
  medications!: Medication[];
  imeis!: Imei[];
  participantStatus!: ParticipantStatus[];

  formSubmitted = false;

  veeFields!: Field;
  veeErrors!: ErrorBag;

  dateTimeConfig = {
    format: 'MM/DD/YYYY hh:mm A',
    showClear: true,
    showClose: true,
    showTodayButton: true,
    toolbarPlacement: 'bottom',
    stepping: 1,
    icons: {
      time: 'fa fa-clock',
      date: 'fa fa-calendar',
      up: 'fa fa-arrow-up',
      down: 'fa fa-arrow-down',
      previous: 'fa fa-chevron-left',
      next: 'fa fa-chevron-right',
      today: 'fa fa-calendar-check',
      clear: 'fa fa-trash',
      close: 'fa fa-times'
    }
  };

  dateConfig = {
    format: 'MM/DD/YYYY',
    showClear: true,
    showClose: true,
    showTodayButton: true,
    toolbarPlacement: 'bottom',
    icons: {
      date: 'fa fa-calendar',
      up: 'fa fa-arrow-up',
      down: 'fa fa-arrow-down',
      previous: 'fa fa-chevron-left',
      next: 'fa fa-chevron-right',
      today: 'fa fa-calendar-check',
      clear: 'fa fa-trash',
      close: 'fa fa-times'
    }
  };

  timeConfig = {
    format: 'hh:mm A',
    showClear: true,
    showClose: true,
    stepping: 1,
    toolbarPlacement: 'bottom',
    icons: {
      time: 'fa fa-clock',
      up: 'fa fa-arrow-up',
      down: 'fa fa-arrow-down',
      previous: 'fa fa-chevron-left',
      next: 'fa fa-chevron-right',
      clear: 'fa fa-trash',
      close: 'fa fa-times'
    }
  };

  getValidationClass(fieldName: keyof Field) {
    const hasError = this.veeErrors.has(fieldName);
    const isValidated = this.validateState(fieldName);
  
    return {
      'is-invalid': hasError,
      'is-valid': this.formSubmitted && !hasError && isValidated
    };
  }

  validateState(ref: keyof Field) {
    if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || 
        this.veeFields[ref].validated)
    ) {
        return !this.veeErrors.has(ref);
    }
    return null;
  }

  getDateTime(datetime: string | Date | null | undefined): string | undefined {
    if (!datetime) return undefined;
    return moment(datetime, "MM/DD/YYYY HH:mm:ss", true).format("MM/DD/YYYY hh:mm A");
  }

  getDate(date: string | Date | null | undefined): string | undefined {
    if (!date) return undefined;
    return moment(date, "YYYY-MM-DD", true).format("MM/DD/YYYY");
  }

  formatDateTime(datetime: string | Date | null | undefined): string | undefined {
    if (!datetime) return undefined;
    return moment(datetime, "MM/DD/YYYY hh:mm A", true).utc().format("YYYY-MM-DD[T]HH:mm:ss");
  }

  formatDate(date: string | Date | null | undefined): string | undefined {
    if (!date) return undefined;
    return moment(date, "MM/DD/YYYY", true).utc().format("YYYY-MM-DD");
  }
  
  formatTime(time: string | Date | null | undefined): string | undefined {
    if (!time) return undefined;
    return moment(time, ["h:mm A"]).utc().format("HH:mm:ss");
  }
}